<template>
  <article class="persona" :class="{ 'is-rounded': rounded }">
    <avatar
      v-bind="{ name, size, presence, identicon, path: avatar }"
      :class="{ 'is-rounded': rounded }"/>
    <div class="persona-meta">
      <p class="persona-name">{{ name }}</p>
      <p class="persona-subtitle" v-if="subtitle">{{ subtitle }}</p>
    </div>
  </article>
</template>

<script>
export default {

  props: {
    avatar: String,
    name: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: '',
    },
    presence: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 48
    },
    rounded: {
      type: Boolean,
      default: true
    },
    empty: {
      type: String,
      default: '?'
    },
    identicon: {
      type: Boolean | String,
      default: false
    },
  },

}
</script>
